module.exports = __webpack_public_path__ + "img/homepage-content-image-lincoln.83dad4ac.jpg";